/* Magic Dust — theme.js
   Scroll-reveal + filter chips + map-point links. */

(function () {
  'use strict';

  // ===== Scroll-reveal =====
  function initReveal() {
    if (typeof IntersectionObserver === 'undefined') {
      document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    document.querySelectorAll('.reveal:not(.in)').forEach(function (el) { io.observe(el); });
  }

  // ===== Filter chips on collection grid =====
  function initFilterChips() {
    document.querySelectorAll('[data-filter-row]').forEach(function (row) {
      var grid = document.querySelector('[data-filter-target="' + row.dataset.filterRow + '"]');
      if (!grid) return;
      var chips = row.querySelectorAll('[data-filter]');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (c) { c.classList.remove('on'); });
          chip.classList.add('on');
          var f = chip.dataset.filter;
          grid.querySelectorAll('[data-tags]').forEach(function (card) {
            var tags = (card.dataset.tags || '').toUpperCase();
            card.style.display = (f === 'ALL' || tags.indexOf(f) >= 0) ? '' : 'none';
          });
        });
      });
    });
  }

  // ===== Drop signup (newsletter via Shopify customer form) =====
  // Shopify customer form handles submission natively; we just disable on submit.
  function initDropForm() {
    document.querySelectorAll('[data-drop-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('button[type="submit"]');
        if (btn) btn.textContent = '· SENDING';
      });
    });
  }

  // ===== Boot =====
  function boot() {
    initReveal();
    initFilterChips();
    initDropForm();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
